import { createEntityAdapter } from '@reduxjs/toolkit'
import type { Upload } from '@buffer-mono/uploader'

export const uploadsAdapter = createEntityAdapter<Upload>()
